export const calculateTotal = ({ reservation, client }) =>
    parseFloat(reservation.schedule.balance.sum) +
    parseFloat(reservation.schedule.deposit.sum) -
    parseFloat(client.guest_credit_amount);
